// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = () => Object.create(null); // Useful for processing arguments objects as well as arrays.


var {
  forEach,
  slice
} = Array.prototype;
var {
  hasOwnProperty
} = Object.prototype;
export class Trie {
  constructor() {
    var weakness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var makeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMakeData;
    this.weakness = weakness;
    this.makeData = makeData;
  }

  lookup() {
    return this.lookupArray(arguments);
  }

  lookupArray(array) {
    var node = this;
    forEach.call(array, key => node = node.getChildTrie(key));
    return hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData(slice.call(array));
  }

  peek() {
    return this.peekArray(arguments);
  }

  peekArray(array) {
    var node = this;

    for (var i = 0, len = array.length; node && i < len; ++i) {
      var map = node.mapFor(array[i], false);
      node = map && map.get(array[i]);
    }

    return node && node.data;
  }

  remove() {
    return this.removeArray(arguments);
  }

  removeArray(array) {
    var data;

    if (array.length) {
      var head = array[0];
      var map = this.mapFor(head, false);
      var child = map && map.get(head);

      if (child) {
        data = child.removeArray(slice.call(array, 1));

        if (!child.data && !child.weak && !(child.strong && child.strong.size)) {
          map.delete(head);
        }
      }
    } else {
      data = this.data;
      delete this.data;
    }

    return data;
  }

  getChildTrie(key) {
    var map = this.mapFor(key, true);
    var child = map.get(key);
    if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
    return child;
  }

  mapFor(key, create) {
    return this.weakness && isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap() : void 0) : this.strong || (create ? this.strong = new Map() : void 0);
  }

}

function isObjRef(value) {
  switch (typeof value) {
    case "object":
      if (value === null) break;
    // Fall through to return true...

    case "function":
      return true;
  }

  return false;
}